import { render } from "./SniplyCampaignAssign.vue?vue&type=template&id=26f6b88a"
import script from "./SniplyCampaignAssign.vue?vue&type=script&lang=js"
export * from "./SniplyCampaignAssign.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__